import { Box, Button } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import CheckPermission from './CheckPermission';
interface ATabProps {
	style: string;
	items: any[];
	active: string | null;
	setActiveItem: Dispatch<SetStateAction<string>>;
}

const ATab: React.FC<ATabProps> = ({ items, style, active, setActiveItem }) => {
	return (
		<Box className={`flex items-center ${style}`}>
			{items.map(item => (
				<div className="">
					<CheckPermission permissions={item.permission && item.permission}>
						<Button size="large" variant={active === item.title ? 'contained' : 'text'} className={`mx-3 ${active === item.title ? '' : 'text-black'} `} onClick={() => setActiveItem(item.title)}>
							<span className="mx-2">{item.icon}</span>
							{item.title}
						</Button>
					</CheckPermission>
				</div>
			))}
		</Box>
	);
};

export default ATab;
